import { GatewayRulesFormValues } from 'pages/GatewayRules/components/GatewayRulesForm/hooks/useGatewayRulesForm';
import { DeepPartial } from 'react-hook-form';
import { ConditionGroup, GatewayRule, Mapping, MappingItem } from 'types/embedded/gatewayRule';

type Props = {
  gatewayRule: GatewayRule;
  mappings: Mapping[];
  mappingItems: MappingItem[];
  conditionGroup: ConditionGroup | null;
};

export function getInitialEditFormValues({
  gatewayRule,
  conditionGroup,
  mappings,
  mappingItems,
}: Props): DeepPartial<GatewayRulesFormValues> {
  const mappingsResult = mappings.map((mapping) => {
    const mappingItemIds = mapping.mappingItems.map((v) => v?.['@id']);

    return {
      ...mapping,
      gatewayRule: gatewayRule?.['@id'],
      method: mapping?.method?.['@id'],
      direction: mapping?.direction?.['@id'],
      mappingItems: mappingItems
        ?.filter((mappingItem) => mappingItemIds.includes(mappingItem?.['@id']))
        ?.map((mappingItem) => ({
          gateway: mappingItem?.gateway?.['@id'],
          merchantAccount: mappingItem?.merchantAccount?.['@id'],
          commissions: mappingItem?.commissions?.map((c) => c?.['@id']),
          subagent: mappingItem?.subagent ?? undefined,
          value: mappingItem?.value,
          badge: mappingItem?.badge?.['@id'],
        })),
    };
  });

  return {
    name: gatewayRule?.name,
    merchant: gatewayRule?.merchant?.['@id'],
    active: gatewayRule?.active,
    conditionGroup,
    mappings: mappingsResult,
  };
}
